/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 全局终端：global_wap（由 CSV 页面终端行派生，B 位重写为 global_wap；200 个 D 位坑位，8 个 C 位模块）。
 * 数据源：home_wap（header_tools、mobile_navigation、site_notice、footer_navigation、footer_help、footer_app、footer_social、footer_subscribe）、product_detail_wap（breadcrumb）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const GLOBAL_WAP_SPM_CODES = {
  footer_app: {
    code: `${sitePrefix}.global_wap.footer_app`,
    download_android_app: `${sitePrefix}.global_wap.footer_app.download_android_app`,
    open_download_on_the_app_store: `${sitePrefix}.global_wap.footer_app.open_download_on_the_app_store`,
  },
  footer_help: {
    code: `${sitePrefix}.global_wap.footer_help`,
    open_help_center: `${sitePrefix}.global_wap.footer_help.open_help_center`,
    open_order_tracking: `${sitePrefix}.global_wap.footer_help.open_order_tracking`,
  },
  footer_navigation: {
    code: `${sitePrefix}.global_wap.footer_navigation`,
    footer_group_toggle_01: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_01`,
    footer_group_toggle_02: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_02`,
    footer_group_toggle_03: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_03`,
    footer_group_toggle_04: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_04`,
    footer_group_toggle_05: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_05`,
    footer_group_toggle_06: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_06`,
    footer_group_toggle_07: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_07`,
    footer_group_toggle_08: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_08`,
    footer_group_toggle_09: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_09`,
    footer_group_toggle_10: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_10`,
    footer_group_toggle_11: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_11`,
    footer_group_toggle_12: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_12`,
    footer_group_toggle_13: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_13`,
    footer_group_toggle_14: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_14`,
    footer_group_toggle_15: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_15`,
    footer_group_toggle_16: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_16`,
    footer_group_toggle_17: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_17`,
    footer_group_toggle_18: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_18`,
    footer_group_toggle_19: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_19`,
    footer_group_toggle_20: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_20`,
    footer_group_toggle_21: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_21`,
    footer_group_toggle_22: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_22`,
    footer_group_toggle_23: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_23`,
    footer_group_toggle_24: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_24`,
    footer_group_toggle_25: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_25`,
    footer_group_toggle_26: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_26`,
    footer_group_toggle_27: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_27`,
    footer_group_toggle_28: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_28`,
    footer_group_toggle_29: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_29`,
    footer_group_toggle_30: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_30`,
    footer_group_toggle_31: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_31`,
    footer_group_toggle_32: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_32`,
    footer_group_toggle_33: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_33`,
    footer_group_toggle_34: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_34`,
    footer_group_toggle_35: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_35`,
    footer_group_toggle_36: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_36`,
    footer_group_toggle_37: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_37`,
    footer_group_toggle_38: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_38`,
    footer_group_toggle_39: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_39`,
    footer_group_toggle_40: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_40`,
    footer_group_toggle_41: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_41`,
    footer_group_toggle_42: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_42`,
    footer_group_toggle_43: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_43`,
    footer_group_toggle_44: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_44`,
    footer_group_toggle_45: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_45`,
    footer_group_toggle_46: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_46`,
    footer_group_toggle_47: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_47`,
    footer_group_toggle_48: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_48`,
    footer_group_toggle_49: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_49`,
    footer_group_toggle_50: `${sitePrefix}.global_wap.footer_navigation.footer_group_toggle_50`,
    footer_link_01: `${sitePrefix}.global_wap.footer_navigation.footer_link_01`,
    footer_link_02: `${sitePrefix}.global_wap.footer_navigation.footer_link_02`,
    footer_link_03: `${sitePrefix}.global_wap.footer_navigation.footer_link_03`,
    footer_link_04: `${sitePrefix}.global_wap.footer_navigation.footer_link_04`,
    footer_link_05: `${sitePrefix}.global_wap.footer_navigation.footer_link_05`,
    footer_link_06: `${sitePrefix}.global_wap.footer_navigation.footer_link_06`,
    footer_link_07: `${sitePrefix}.global_wap.footer_navigation.footer_link_07`,
    footer_link_08: `${sitePrefix}.global_wap.footer_navigation.footer_link_08`,
    footer_link_09: `${sitePrefix}.global_wap.footer_navigation.footer_link_09`,
    footer_link_10: `${sitePrefix}.global_wap.footer_navigation.footer_link_10`,
    footer_link_11: `${sitePrefix}.global_wap.footer_navigation.footer_link_11`,
    footer_link_12: `${sitePrefix}.global_wap.footer_navigation.footer_link_12`,
    footer_link_13: `${sitePrefix}.global_wap.footer_navigation.footer_link_13`,
    footer_link_14: `${sitePrefix}.global_wap.footer_navigation.footer_link_14`,
    footer_link_15: `${sitePrefix}.global_wap.footer_navigation.footer_link_15`,
    footer_link_16: `${sitePrefix}.global_wap.footer_navigation.footer_link_16`,
    footer_link_17: `${sitePrefix}.global_wap.footer_navigation.footer_link_17`,
    footer_link_18: `${sitePrefix}.global_wap.footer_navigation.footer_link_18`,
    footer_link_19: `${sitePrefix}.global_wap.footer_navigation.footer_link_19`,
    footer_link_20: `${sitePrefix}.global_wap.footer_navigation.footer_link_20`,
    footer_link_21: `${sitePrefix}.global_wap.footer_navigation.footer_link_21`,
    footer_link_22: `${sitePrefix}.global_wap.footer_navigation.footer_link_22`,
    footer_link_23: `${sitePrefix}.global_wap.footer_navigation.footer_link_23`,
    footer_link_24: `${sitePrefix}.global_wap.footer_navigation.footer_link_24`,
    footer_link_25: `${sitePrefix}.global_wap.footer_navigation.footer_link_25`,
    footer_link_26: `${sitePrefix}.global_wap.footer_navigation.footer_link_26`,
    footer_link_27: `${sitePrefix}.global_wap.footer_navigation.footer_link_27`,
    footer_link_28: `${sitePrefix}.global_wap.footer_navigation.footer_link_28`,
    footer_link_29: `${sitePrefix}.global_wap.footer_navigation.footer_link_29`,
    footer_link_30: `${sitePrefix}.global_wap.footer_navigation.footer_link_30`,
    footer_link_31: `${sitePrefix}.global_wap.footer_navigation.footer_link_31`,
    footer_link_32: `${sitePrefix}.global_wap.footer_navigation.footer_link_32`,
    footer_link_33: `${sitePrefix}.global_wap.footer_navigation.footer_link_33`,
    footer_link_34: `${sitePrefix}.global_wap.footer_navigation.footer_link_34`,
    footer_link_35: `${sitePrefix}.global_wap.footer_navigation.footer_link_35`,
    footer_link_36: `${sitePrefix}.global_wap.footer_navigation.footer_link_36`,
    footer_link_37: `${sitePrefix}.global_wap.footer_navigation.footer_link_37`,
    footer_link_38: `${sitePrefix}.global_wap.footer_navigation.footer_link_38`,
    footer_link_39: `${sitePrefix}.global_wap.footer_navigation.footer_link_39`,
  },
  footer_social: {
    code: `${sitePrefix}.global_wap.footer_social`,
    social_entry_01: `${sitePrefix}.global_wap.footer_social.social_entry_01`,
    social_entry_02: `${sitePrefix}.global_wap.footer_social.social_entry_02`,
    social_entry_03: `${sitePrefix}.global_wap.footer_social.social_entry_03`,
    social_entry_04: `${sitePrefix}.global_wap.footer_social.social_entry_04`,
    social_entry_05: `${sitePrefix}.global_wap.footer_social.social_entry_05`,
    social_entry_06: `${sitePrefix}.global_wap.footer_social.social_entry_06`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.global_wap.footer_subscribe`,
    email_input: `${sitePrefix}.global_wap.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.global_wap.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.global_wap.header_tools`,
    cart_entry: `${sitePrefix}.global_wap.header_tools.cart_entry`,
    logo_entry: `${sitePrefix}.global_wap.header_tools.logo_entry`,
    open_account: `${sitePrefix}.global_wap.header_tools.open_account`,
    open_search: `${sitePrefix}.global_wap.header_tools.open_search`,
    toggle_navigation: `${sitePrefix}.global_wap.header_tools.toggle_navigation`,
  },
  mobile_navigation: {
    code: `${sitePrefix}.global_wap.mobile_navigation`,
    nav_item_01: `${sitePrefix}.global_wap.mobile_navigation.nav_item_01`,
    nav_item_02: `${sitePrefix}.global_wap.mobile_navigation.nav_item_02`,
    nav_item_03: `${sitePrefix}.global_wap.mobile_navigation.nav_item_03`,
    nav_item_04: `${sitePrefix}.global_wap.mobile_navigation.nav_item_04`,
    nav_item_05: `${sitePrefix}.global_wap.mobile_navigation.nav_item_05`,
    nav_item_06: `${sitePrefix}.global_wap.mobile_navigation.nav_item_06`,
    open_contact_us: `${sitePrefix}.global_wap.mobile_navigation.open_contact_us`,
    open_help_center: `${sitePrefix}.global_wap.mobile_navigation.open_help_center`,
    open_order_tracking: `${sitePrefix}.global_wap.mobile_navigation.open_order_tracking`,
    site_settings_entry: `${sitePrefix}.global_wap.mobile_navigation.site_settings_entry`,
    social_entry_01: `${sitePrefix}.global_wap.mobile_navigation.social_entry_01`,
    social_entry_02: `${sitePrefix}.global_wap.mobile_navigation.social_entry_02`,
    social_entry_03: `${sitePrefix}.global_wap.mobile_navigation.social_entry_03`,
    social_entry_04: `${sitePrefix}.global_wap.mobile_navigation.social_entry_04`,
    social_entry_05: `${sitePrefix}.global_wap.mobile_navigation.social_entry_05`,
    social_entry_06: `${sitePrefix}.global_wap.mobile_navigation.social_entry_06`,
    submenu_item_01_01: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_01`,
    submenu_item_01_02: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_02`,
    submenu_item_01_03: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_03`,
    submenu_item_01_04: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_04`,
    submenu_item_01_05: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_05`,
    submenu_item_01_06: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_06`,
    submenu_item_01_07: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_07`,
    submenu_item_01_08: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_08`,
    submenu_item_01_09: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_09`,
    submenu_item_01_10: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_10`,
    submenu_item_01_11: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_11`,
    submenu_item_01_12: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_12`,
    submenu_item_01_13: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_13`,
    submenu_item_01_14: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_14`,
    submenu_item_01_15: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_15`,
    submenu_item_01_16: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_16`,
    submenu_item_01_17: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_17`,
    submenu_item_01_18: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_18`,
    submenu_item_01_19: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_19`,
    submenu_item_01_20: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_20`,
    submenu_item_01_21: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_21`,
    submenu_item_01_22: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_22`,
    submenu_item_01_23: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_23`,
    submenu_item_01_24: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_24`,
    submenu_item_01_25: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_25`,
    submenu_item_01_26: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_26`,
    submenu_item_01_27: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_27`,
    submenu_item_01_28: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_28`,
    submenu_item_01_29: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_29`,
    submenu_item_01_30: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_30`,
    submenu_item_01_31: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_01_31`,
    submenu_item_02_01: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_01`,
    submenu_item_02_02: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_02`,
    submenu_item_02_03: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_03`,
    submenu_item_02_04: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_04`,
    submenu_item_02_05: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_05`,
    submenu_item_02_06: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_02_06`,
    submenu_item_03_01: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_01`,
    submenu_item_03_02: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_02`,
    submenu_item_03_03: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_03`,
    submenu_item_03_04: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_04`,
    submenu_item_03_05: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_05`,
    submenu_item_03_06: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_06`,
    submenu_item_03_07: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_07`,
    submenu_item_03_08: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_08`,
    submenu_item_03_09: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_09`,
    submenu_item_03_10: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_10`,
    submenu_item_03_11: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_11`,
    submenu_item_03_12: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_12`,
    submenu_item_03_13: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_13`,
    submenu_item_03_14: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_14`,
    submenu_item_03_15: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_15`,
    submenu_item_03_16: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_16`,
    submenu_item_03_17: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_17`,
    submenu_item_03_18: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_18`,
    submenu_item_03_19: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_19`,
    submenu_item_03_20: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_03_20`,
    submenu_item_04_01: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_01`,
    submenu_item_04_02: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_02`,
    submenu_item_04_03: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_03`,
    submenu_item_04_04: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_04`,
    submenu_item_04_05: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_05`,
    submenu_item_04_06: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_06`,
    submenu_item_04_07: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_07`,
    submenu_item_04_08: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_08`,
    submenu_item_04_09: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_09`,
    submenu_item_04_10: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_10`,
    submenu_item_04_11: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_11`,
    submenu_item_04_12: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_12`,
    submenu_item_04_13: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_13`,
    submenu_item_04_14: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_14`,
    submenu_item_04_15: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_15`,
    submenu_item_04_16: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_16`,
    submenu_item_04_17: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_17`,
    submenu_item_04_18: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_18`,
    submenu_item_04_19: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_19`,
    submenu_item_04_20: `${sitePrefix}.global_wap.mobile_navigation.submenu_item_04_20`,
  },
  site_notice: {
    code: `${sitePrefix}.global_wap.site_notice`,
    open_promotion: `${sitePrefix}.global_wap.site_notice.open_promotion`,
  },
} as const satisfies SpmPageCodes;
